import styled from 'styled-components';

export const WarningStatus = styled.div`
   width: 147px;
    height: 42px;
    border-radius: 16px;
    border: 1px solid #F26A1D;
    background: rgba(249, 146, 42, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 9px 30px 9px 30px;

    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`